import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { MediaAPIService } from '../media/media.service';
import { FileManagementApiService } from './file-management-api.service';
import { Observable, Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class FileManagementService {
	constructor(
		private mediaAPIService: MediaAPIService,
		private fileManagementApiService: FileManagementApiService
	) { }

	//cards need these events to communicate with carousel
	
	//let carousel know when folder has been deleted
	private folderDeletedSubject: Subject<any> = new Subject<any>();	
	emitFolderDeletedEvent(data: any) {
		this.folderDeletedSubject.next(data);
	}
	getFolderDeletedEventAsObservable(): Observable<any> {
		return this.folderDeletedSubject.asObservable();
	}

	//let carousel know when folder has been renamed
	private folderRenamedSubject: Subject<any> = new Subject<any>();
	emitFolderRenamedEvent(data: any) {
		this.folderRenamedSubject.next(data);
	}
	getFolderRenamedEventAsObservable(): Observable<any> {
		return this.folderRenamedSubject.asObservable();
	}

	getFileTypeIconImgSrc(fileName: string): string {
		let fileNameParts: string[] = fileName.split(".");
		let ext: string = fileNameParts.length > 1 ? fileNameParts[fileNameParts.length - 1] : "";
		//if (ext.length === 0) {
		//	ext = file.type.replace(/(.*)\//g, '');
		//}
		if (ext.length === 0) {
			ext = "unknown";
		}

		let iconImgSrc: string = this.mediaAPIService.getIcon(ext, 64);

		return iconImgSrc;
	}

	getFormattedDateFromTimeStamp(timeStamp: string) {
		return new Intl.DateTimeFormat('en-US', {
			year: 'numeric', month: 'long', day: 'numeric',
			hour: 'numeric', minute: 'numeric',
			hour12: true // Use 12-hour clock format
		}).format(new Date(timeStamp));
	}


	confirmRenameFolder(folderName: string): Promise<any> {
		return Swal.fire({
			title: "Rename Folder",
			html: "Current folder name: <b>" + folderName + "</b>",
			input: "text",
			inputPlaceholder: "New folder name",
			showCancelButton: true,
		});
	}

	confirmDeleteFolder(folderName: any): Promise<any> {
		return Swal.fire({
			title: "Delete Folder",
			html: "<b>" + folderName + "</b> and all files and folders within it will be deleted.",
			confirmButtonText: 'Delete',
			cancelButtonText: 'Cancel',
			//inputLabel: "Folder Name",			
			showCancelButton: true,
		});
	}

	confirmCreateFolder(): Promise<any> {
		return Swal.fire({
			title: "Create New Folder",
			//text: "Enter name of new folder"
			input: "text",
			//inputLabel: "Folder Name",
			inputPlaceholder: "Folder name",
			showCancelButton: true,
		});
	}





	
}
